<template>
  <div id="tryout-form">
    <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
      <span class="close" data-dismiss="alert">&times;</span>
      <strong>Terjadi kesalahan!</strong>
      <ul>
        <li v-for="(message, key) in this.errors" :key="key">{{message}}</li>
      </ul>
    </div>
    <div class="form-horizontal form-bordered">
      <div class="form-group">
        <label class="col-md-2 control-label">Judul *</label>
        <div class="col-md-8 col-xs-12">
          <input v-model="tryout.name" class="form-control" type="text" name="name" placeholder="Judul Tryout">
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Deskripsi *</label>
        <div class="col-md-8 col-xs-12">
          <input v-model="tryout.description" class="form-control" type="text" name="description" placeholder="Deskripsi Tryout">
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Tryout Instan</label>
        <div class="col-md-8 col-xs-12">
          <div class="checkbox">
            <label>
              <input v-model="tryout.is_repeated" type="checkbox" value="is_repeated"></label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Jenjang *</label>
        <div class="col-md-8 col-xs-12">
          <select v-model="tryout.level" class="form-control" @change="selectingLevel()" name="level">
            <!-- <option value="UMUM">Umum</option> -->
            <option value="SMA">SMA</option>
            <option value="SMP">SMP</option>
            <option value="SD">SD</option>
          </select>
        </div>
      </div>
      <div class="form-group" v-if="tryout.is_repeated">
        <label class="col-md-2 control-label">Kelas *</label>
        <div class="col-md-8 col-xs-12">
          <select v-model="tryout_grade" class="form-control" name="level">
            <option v-for="(item,index) in gradeList" :key="index" :value="item">{{item}}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Jenis *</label>
        <div class="col-md-8 col-xs-12">
          <select v-model="tryout.type" class="form-control" name="type">
            <option value="SBMPTN">SNBT</option>
            <option value="UJIAN_AKHIR_NASIONAL">Ujian Nasional (UN)</option>
            <option value="UJIAN_AKHIR_SEKOLAH">Ujian Akhir Sekolah (UAS)</option>
            <option value="UJIAN_SEKOLAH">Ujian Sekolah</option>
            <option value="PENILAIAN_TENGAH_SEMESTER">Penilaian Tengah Semester (PTS)</option>
            <option value="PENILAIAN_AKHIR_SEMESTER">Penilaian Akhir Semester (PAS)</option>
            <option value="UJIAN_MANDIRI">Ujian Mandiri (UM)</option>
          </select>
        </div>
      </div>
      <div class="form-group" v-if="tryout.type == 'SBMPTN' && tryout.level == 'SMA'">
        <label class="col-md-2 control-label">Kategori *</label>
        <div class="col-md-8 col-xs-12">
          <select v-model="tryout.category" class="form-control" name="category">
            <option value="TPS">TPS</option>
            <option value="LITERASI">LITERASI</option>
            <option value="SAINTEK">SAINTEK</option>
            <option value="SOSHUM">SOSHUM</option>
            <option value="OTHER">OTHER</option>
            <option value="TKPA">TKPA (Sudah Tidak Berlaku)</option>
          </select>
        </div>
      </div>
      <div class="form-group" v-else-if="tryout.type != 'SBMPTN' && tryout.level == 'SMA'">
        <label class="col-md-2 control-label">Kategori *</label>
        <div class="col-md-8 col-xs-12">
          <select v-model="tryout.category" class="form-control" name="category">
            <option value="SAINTEK">SAINTEK</option>
            <option value="SOSHUM">SOSHUM</option>
            <option value="OTHER">OTHER</option>
          </select>
        </div>
      </div>
      <div class="form-group" v-else>
        <label class="col-md-2 control-label">Kategori *</label>
        <div class="col-md-8 col-xs-12">
          <select v-model="tryout.category" class="form-control" name="category">
            <option value="OTHER">OTHER</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Durasi (Menit) *</label>
        <div class="col-md-8 col-xs-12">
          <input v-model="tryout.duration" class="form-control" type="number" min="0" name="name">
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Mulai</label>
        <transition name="fade">
          <div class="col-md-4 col-xs-12">
            <div class="input-group">
              <input id="startDate" v-model="tryout.start_date" type="text" class="form-control datepicker" placeholder="Tanggal" name="start_date" readonly>
              <span class="input-group-btn">
                <button class="btn btn-success" type="button">
                  <i class="fa fa-calendar"></i>
                </button>
              </span>
            </div>
          </div>
        </transition>
        <div class="col-md-4 col-xs-12">
          <div class="input-group clockpicker">
            <input id="startTime" v-model="tryout.start_time" type="text" class="form-control" placeholder="Jam : Menit" name="start_time" readonly>
            <span class="input-group-btn">
              <button class="btn btn-success" type="button">
                <i class="fa fa-clock-o"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Berakhir</label>
        <transition name="fade">
          <div class="col-md-4 col-xs-12">
            <div class="input-group">
              <input id="endDate" v-model="tryout.end_date" type="text" class="form-control datepicker" placeholder="Tanggal" name="end_date" readonly>
              <span class="input-group-btn">
                <button class="btn btn-success" type="button">
                  <i class="fa fa-calendar"></i>
                </button>
              </span>
            </div>
          </div>
        </transition>
        <div class="col-md-4 col-xs-12">
          <div class="input-group clockpicker">
            <input id="endTime" v-model="tryout.end_time" type="text" class="form-control" placeholder="Jam : Menit" name="end_time" readonly>
            <span class="input-group-btn">
              <button class="btn btn-success" type="button">
                <i class="fa fa-clock-o"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Form -->
    <hr>
    <div class="pull-right">
      <button type="button" class="btn btn-success" @click="submit()">Selanjutnya</button>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import TryoutService from "@/services/tryout.js";
import Tryout from "@/components/tryout/models/Tryout.js";
import Spinner from "@/components/plugins/Spinner";
import moment from "moment";

export default {
  name: "tryout-form",
  components: {
    "app-spinner": Spinner
  },
  data: function () {
    return {
      isLoading: false,
      errors: [],
      tryout: { id: 0, is_repeated: false, is_free_access: false, category: 'OTHER' },
      selectLevel: null,
      gradeList: [],
      tryout_grade: null,
    }
  },
  methods: {
    submit: function () {
      var context = this;

      if (this.validateForm()) {
        context.isLoading = true;
        if(context.tryout.is_repeated) context.tryout.description += ' || ' + context.tryout_grade
        if (this.tryout.id == 0) {
          TryoutService.saveTryout(this.tryout, function (result) {
            context.isLoading = false
            if (result.success) {
              context.storeTryoutAndCompleteTransaction(result.data)
            }
          })
        } else {
          TryoutService.updateTryout(this.tryout, function (result) {
            context.isLoading = false
            if (result.success) {
              context.storeTryoutAndCompleteTransaction(result.data)
            }
          })
        }
      } else {
        $(window).scrollTop(0)
      }
    },
    storeTryoutAndCompleteTransaction: function (data) {
      this.$store.commit('tryout_init', data)
      this.$emit('completed')
    },
    validateForm: function () {
      this.errors = []

      let startTimeFull = moment(`${this.tryout.start_date} ${this.tryout.start_time}`).format()
      let endTimeFull = moment(`${this.tryout.end_date} ${this.tryout.end_time}`).format()

      if(this.tryout.is_repeated && this.tryout_grade === null) this.errors.push('Tryout Instan wajib mengisi kelas')

      /**
       * di takeout atas request pak gatra bisa bikin tryout dengan tanggal yang sudah lewat
       * biar bisa langsung muncul TO nya. (Biasanya untuk TO coba-coba)
       *
       * if (moment(startTimeFull).isBefore(moment().format())) {
       *     this.errors.push('tanggal dan waktu mulai sudah lewat')
       * } else {
       *   if (!moment(endTimeFull).isAfter(startTimeFull)) {
       *     this.errors.push('tanggal dan waktu mulai harus melebihi tanggal dan waktu berakhir')
       *   }
       * }
       */

      if (!moment(endTimeFull).isAfter(startTimeFull)) {
        this.errors.push('tanggal dan waktu mulai harus melebihi tanggal dan waktu berakhir')
      }

      return this.errors.length == 0
    },
    selectingLevel(){
      if(this.tryout.level === 'SD') this.gradeList = [4,5,6]
      if(this.tryout.level === 'SMP') this.gradeList = [7,8,9]
      if(this.tryout.level === 'SMA') this.gradeList = [10,11,12]
      var des = this.tryout.description
      var res = des.split("||")
      this.tryout_grade = parseInt(res[1])
      this.tryout.description = res[0]
    }
  },
  mounted: function () {
    if (this.$store.state.tryout.id > 0) this.tryout = this.$store.state.tryout
    var context = this
    DatepickerPlugin.init("#startDate", function (value) {
      context.tryout.start_date = moment(value, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      )
    })

    DatepickerPlugin.init("#endDate", function (value) {
      context.tryout.end_date = moment(value, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      )
    })

    ClockpickerPlugin.init("#startTime", function (value) {
      context.tryout.start_time = value + ":00";
    })

    ClockpickerPlugin.init("#endTime", function (value) {
      context.tryout.end_time = value + ":00";
    })
    this.selectingLevel()
  },
  watch: {
    'tryout.type': function (val) {
      // if (val != 'SBMPTN') this.tryout.category = 'OTHER'
    }
  }
};
</script>



// WEBPACK FOOTER //
// TryoutForm.vue?419afe0a